import { Box, Grid, Typography } from '@mui/material'
import { BerthPlanningViewStore } from '@planning/pages/BerthPlanning/Stores/BerthPlanningViewStore'
import { VesselVisitBerthAndTimingFormStore } from '@planning/pages/VesselVisit/Stores/VesselVisitBerthAndTimingFormStore'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { WarningIcon } from 'modules/ui/src/theme/overrides/CustomIcons'
import { useEffect } from 'react'
import { NumberFieldWithUnit } from '../../atoms/NumberFieldWithUnit'

export const VesselFields = observer(
  ({
    store,
    berthPlanningViewStore,
  }: {
    store: VesselVisitBerthAndTimingFormStore
    berthPlanningViewStore: BerthPlanningViewStore
  }) => {
    const { t } = useTranslate()

    const arrivalDraft = Number(store.draftArrival.value)
    const departureDraft = Number(store.draftDeparture.value)

    const { conflictingBerthDraft } = store

    useEffect(() => {
      const vessel = berthPlanningViewStore.selectedVessels ?? []
      const newLength = vessel?.[0]?.length

      if (newLength != null && store.length.value !== newLength) {
        store.length.setValue(newLength)
      }
    }, [berthPlanningViewStore.selectedVessels, store.length])

    return (
      <>
        {/* VESSEL */}
        <Grid size={{ xs: 12 }}>
          <Typography variant='subtitle1'>{t('vessel', 'Vessel')}</Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <NumberFieldWithUnit
            name='length'
            label={t('length', 'Length')}
            unit='m'
            disabled
            fieldStoreProps={store.length.props}
          />
        </Grid>

        {/* DRAFTS */}
        <Grid size={{ xs: 12 }}>
          <Typography variant='subtitle1'>{t('drafts', 'Drafts')}</Typography>
        </Grid>

        <Grid size={{ xs: 6 }}>
          <NumberFieldWithUnit
            name='draftArrival'
            label={t('Arrival', 'Arrival')}
            unit='m'
            fieldStoreProps={store.draftArrival.props}
          />
        </Grid>

        <Grid size={{ xs: 6 }}>
          <NumberFieldWithUnit
            name='draftDeparture'
            label={t('departure', 'Departure')}
            unit='m'
            fieldStoreProps={store.draftDeparture.props}
          />
        </Grid>

        {!!conflictingBerthDraft && (
          <Grid size={{ xs: 12 }}>
            <Box display='flex' alignItems='center' gap={1}>
              <WarningIcon color='warning' fontSize='small' />
              <Typography variant='body2' color='#7A4F01'>
                {t(
                  'draftWarning',
                  `Arrival/departure drafts (${arrivalDraft}m/${departureDraft}m) are deeper than the berth draft (${conflictingBerthDraft}m).`,
                )}
              </Typography>
            </Box>
          </Grid>
        )}
      </>
    )
  },
)
